import * as React from 'react'
import Table, { TableFilters, TableHeaderValue } from '@components/table/table'
import { CmsAssetCategoriesTableRow } from '@modules/cms/assets/categories/table-row'
import { AssetCategory } from '@models/cms-asset'
import { assetCategoriesSelector } from '@store/slices/assets-slice'
import { useAppSelector } from '@store/index'

interface Props {
  isLoading: boolean
}

const headerValues: TableHeaderValue<AssetCategory>[] = [{ title: 'Nazwa', sortField: 'name' }, { title: '' }]

export const CmsAssetCategoriesTable = ({ isLoading }: Props): JSX.Element => {
  const categories = useAppSelector(assetCategoriesSelector)

  const [filters, setFilters] = React.useState<TableFilters>({
    ordering: 'name',
    page: 1,
    page_size: 9999,
    search: '',
  })

  return (
    <Table
      filters={filters}
      setFilters={setFilters}
      headerValues={headerValues}
      isLoading={isLoading}
      showPagination={false}
    >
      {categories.map(row => (
        <CmsAssetCategoriesTableRow key={row.id} category={row} />
      ))}
    </Table>
  )
}
